/**
 * Home publica = a home do Cabal Next (next/NextHome, mockup do dono 2026-10-10).
 * Os componentes da home antiga (./components: noticias, ranking, guerra, streamers, header/footer) ficam no
 * projeto de proposito: tem chamadas de API pra reaproveitar nas secoes novas.
 */
import NextHome from './next/NextHome';

export default function HomePage() {
  return <NextHome />;
}
